export default {
  props: ['state'],
	created: function () {
	},
	methods: {
	}
}
